import { SET_OPINION, SET_OPINIONS, LOADING_DATA, HATE_OPINION, UNHATE_OPINION, IGNORE_OPINION, UNIGNORE_OPINION, DELETE_OPINION, SET_ERRORS, CLEAR_ERRORS, POST_OPINION, LOADING_UI, STOP_LOADING_UI, SUBMIT_WRECK } from '../types'
import axios from 'axios'

export const getOpinions = () => (dispatch) => {
    dispatch({ type: LOADING_DATA });
    axios.get('/wrecks')
    .then((res) => {
        dispatch({
            type: SET_OPINIONS,
            payload: res.data
        })
    })
    .catch((err) => {
        dispatch({
        type: SET_OPINIONS,
        payload: []
        })
    });
}

export const getOpinion = (wreckID) => (dispatch) => {
    dispatch({type: LOADING_UI});
    axios.get(`/wreck/${wreckID}`)
    .then((res) => {
        dispatch({
            type: SET_OPINION,
            payload: res.data
        });
        dispatch({type: STOP_LOADING_UI});
    })
    .catch(err => console.error(err)); 
}

export const postOpinion = (newWreck) => (dispatch) => {
    dispatch({type:LOADING_UI });
    axios.post(`/wreck`, newWreck)
    .then((res) => {
        dispatch({
            type: POST_OPINION,
            payload: res.data
        });
        dispatch(clearErrors());
    })
    .catch((err) => {
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
        })
    })
}

export const hateOpinion = (wreckID) => (dispatch) => {
    axios.get('/wreck/'+ wreckID +'/like')
    .then((res) => {
        dispatch({
            type: HATE_OPINION,
            payload: res.data
        })
    })
    .catch(err => console.error(err));
}


export const unhateOpinion = (wreckID) => (dispatch) => {
    axios.get('/wreck/'+ wreckID +'/dislike')
    .then((res) => {
        dispatch({
            type: UNHATE_OPINION,
            payload: res.data
        })
    })
    .catch(err => console.error(err));
}

export const ignoreOpinion = (wreckID) => (dispatch) => {
    axios.get('/wreck/'+ wreckID +'/ignore')
    .then((res) => {
        dispatch({
            type: IGNORE_OPINION,
            payload: res.data
        })
    })
    .catch(err => console.error(err));
}


export const unignoreOpinion = (wreckID) => (dispatch) => {
    axios.get('/wreck/'+ wreckID +'/unignore')
    .then((res) => {
        dispatch({
            type: UNIGNORE_OPINION,
            payload: res.data
        })
    })
    .catch(err => console.error(err));
}

export const submitWreck = (wreckID, commentData) => (dispatch) => {
    axios.post(`/wreck/${wreckID}/comment`, commentData)
    .then((res) => {
        dispatch({
            type: SUBMIT_WRECK,
            payload: { wreckID: wreckID, comment: res.data }
        });
        dispatch(clearErrors());
    })
    .catch((err) => {
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
        })
    })
}

export const deleteOpinion = (wreckID) => (dispatch) => {
    axios.delete(`/wreck/${wreckID}`)
    .then(() => {
        dispatch({
            type: DELETE_OPINION,
            payload: wreckID
        })
    })
    .catch((err) => console.error(err));
}

export const getUserData = (userHandle) => (dispatch) => {
    dispatch({type: LOADING_DATA});
    axios.get(`/user/${userHandle}`)
    .then((res) => {
        dispatch({
            type:SET_OPINIONS,
            payload: res.data.wrecks
        });
    })
    .catch(() => {
        dispatch({
            type: SET_OPINIONS,
            payload: null
        })
    })
} 

export const clearErrors = () => (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
  };